import { X } from 'phosphor-react';
import React from 'react';
import { EmptyState } from './components/EmptyState';
import { Pagination } from './components/Pagination';
import { PartnerCard } from './components/PartnerCard';
import { SearchField } from './components/SearchField';
import { usePartners } from './hooks/usePartners';
import * as S from './styles';

interface PartnersPickerProps {
  onClose: () => void;
}

export const PartnersPicker: React.FC<PartnersPickerProps> = ({ onClose }) => {
  const {
    partners,
    searchText,
    pageNumber,
    totalPages,
    totalCount,
    isLoading,
    debouncedSearchText,
    handleSearch,
    isSearching,
    selectPartner,
    goToPage,
  } = usePartners();

  return (
    <S.Overlay>
      <S.Modal aria-labelledby="partners-picker-title" role="dialog">
        <S.Header>
          <S.Title id="partners-picker-title">
            Switch Account <S.Count>({totalCount})</S.Count>
          </S.Title>
          <S.CloseButton onClick={onClose} aria-label="Close">
            <X weight="bold" />
          </S.CloseButton>
        </S.Header>

        <SearchField value={searchText} onChange={handleSearch} isSearching={isSearching} />

        <S.Content>
          {isLoading && !isSearching ? (
            <S.LoadingState />
          ) : partners.length > 0 ? (
            <S.Grid>
              {partners.map((partner) => (
                <PartnerCard key={partner.id} partner={partner} onSelect={selectPartner} />
              ))}
            </S.Grid>
          ) : (
            <EmptyState query={debouncedSearchText} />
          )}
        </S.Content>

        {totalPages > 1 && <Pagination currentPage={pageNumber} totalPages={totalPages} onPageChange={goToPage} />}
      </S.Modal>
    </S.Overlay>
  );
};
